import React, { useState } from "react";
import BoxComponent from "../../../../components/Box/BoxComponent";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import ButtonComponent from "../../../../components/Button/ButtonComponent";
import { CatalogoCategoria, ItemCategoria } from "../../../../interface/item/categoria/ItemCategoria";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

interface CatalogoAdminCategoriasProps {
    categorias: ItemCategoria[];
    categoriaSelecionada?: ItemCategoria;
    onChangeCategoriaSelecionada: (categoria: ItemCategoria) => void;

    onClickEditarCategoria: (categoria: CatalogoCategoria) => void;
    onClickDeleteCategoria: (categoria: CatalogoCategoria) => void;
}

const CatalogoAdminCategorias = (props: CatalogoAdminCategoriasProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [categoriaMenu, setCategoriaMenu] = useState<CatalogoCategoria | null>(null);

    const open = Boolean(anchorEl);

    const handleOpenMenu = (
        event: React.MouseEvent<HTMLElement>,
        categoria: CatalogoCategoria
    ) => {
        setAnchorEl(event.currentTarget);
        setCategoriaMenu(categoria);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
        setCategoriaMenu(null);
    };

    const handleEditar = () => {
        if (!categoriaMenu) return;
        handleCloseMenu();
        props.onClickEditarCategoria(categoriaMenu);
    };

    const handleExcluir = () => {
        if (!categoriaMenu) return;
        handleCloseMenu();
        props.onClickDeleteCategoria(categoriaMenu);
    };

    const renderButtons = (item: any) => {
        return item.map((element: any, index: number) => {
            const isCategoriaEscolhida = props.categoriaSelecionada?.value === element.value;
            const isPossuiApenasUmItem = element.count == 1;

            return <ButtonComponent
                id={`categoria-${index}`} key={`categoria-${index}`}
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    backgroundColor: isCategoriaEscolhida ? "#FFE4D0" : "transparent",
                    borderRadius: 0,
                    p: "12px 16px"
                }}
                onClick={() => props.onChangeCategoriaSelecionada(element)}
            >
                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column" }}>
                    <TypographyComponent
                        variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                            color: isCategoriaEscolhida ? "#FF8C42" : '#666666',
                            display: 'inline-flex',
                            alignItems: 'center',
                            verticalAlign: 'middle',
                            textTransform: "capitalize"
                        }}
                    >
                        {element.label}
                    </TypographyComponent>
                    <TypographyComponent
                        variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '16px',
                            letterSpacing: '0%',
                            color: '#666666',
                            backgroundColor: '#E8DFD5',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            //width: 16,
                            textTransform: "capitalize"
                        }}>
                        {element.count} {isPossuiApenasUmItem ? "item" : "itens"}

                    </TypographyComponent>
                </BoxComponent>

                <BoxComponent component="div" sx={{ display: "flex", flexDirection: "column" }}>
                    <ButtonComponent id={`categoria-${element.id}`}
                        onClick={(e) => handleOpenMenu(e, element)}
                        sx={{
                            minWidth: 32,
                            width: 32,
                            height: 32,
                            padding: 0
                        }}
                    >
                        <MoreVertIcon fontSize="small" />
                    </ButtonComponent>
                    {/* <TypographyComponent
                        variant="body2"
                        sx={{
                            fontFamily: '"Font 7", sans-serif',
                            fontWeight: 400,
                            fontSize: '12px',
                            lineHeight: '16px',
                            letterSpacing: '0%',
                            color: '#666666',
                            backgroundColor: '#E8DFD5',
                            padding: '2px 8px',
                            borderRadius: '4px',
                            width: 16,
                            textTransform: "capitalize"
                        }}>
                        {element.count}
                    </TypographyComponent> */}
                </BoxComponent>
            </ButtonComponent>
        });
    }

    return <>
        <BoxComponent component="div" sx={{
            p: 2,
            borderBottom: "1px solid #E8DFD5"
        }}>
            <TypographyComponent
                variant="h3"
                sx={{
                    fontFamily: '"Font 7", sans-serif',
                    fontWeight: 700,
                    fontSize: '14px',
                    lineHeight: '20px',
                    letterSpacing: '0%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle',
                    color: "#2C2C2C"
                }}>
                Categorias
            </TypographyComponent>
        </BoxComponent>
        <BoxComponent component="div" sx={{
            display: "flex",
            flexDirection: "column",
            p: 0
        }}>
            {renderButtons(props.categorias)}
        </BoxComponent>
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseMenu}
        >
            <MenuItem onClick={handleEditar}>
                <ListItemIcon>
                    <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Editar</ListItemText>
            </MenuItem>

            <MenuItem
                onClick={handleExcluir}
                sx={{ color: "error.main" }}
            >
                <ListItemIcon>
                    <DeleteOutlineIcon color="error" fontSize="small" />
                </ListItemIcon>
                <ListItemText>Excluir</ListItemText>
            </MenuItem>
        </Menu>
    </>;
}

export default CatalogoAdminCategorias;